import { render, staticRenderFns } from "./ui-textarea.vue?vue&type=template&id=34653cbc&scoped=true&"
import script from "./ui-textarea.vue?vue&type=script&lang=js&"
export * from "./ui-textarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34653cbc",
  null
  
)

export default component.exports